import { registerPlugin } from '@capacitor/core';
const LingoCapacitor = registerPlugin('LingoCapacitor', {
    web: () => import('./web').then(m => new m.LingoCapacitorWeb()),
});
export * from './definitions';
export { LingoCapacitor };
//# sourceMappingURL=index.js.map